module.exports = __webpack_public_path__ + "cancel-white.svg?3709ff3f683117f89f2379a02489187e";